import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType, MonetizableEnum } from '@repo/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph-schemas/marketplace/enums';
import type { BaseMarketplaceEntityType } from '@repo/supergraph-schemas/marketplace/types';

export const ProductImageWrapper = ({
  marketplaceEntity,
  index,
  children,
}: {
  marketplaceEntity: BaseMarketplaceEntityType;
  index: number;
  children: React.ReactNode;
}) => {
  const { cta, monetizable, id, institution, product, productType } = marketplaceEntity;

  return (
    <>
      {cta?.link ? (
        <CtaLink
          cta={{
            link: cta.link,
            type: EntityPlacementCtaTypeEnum.ProductImage,
            text: cta.text,
          }}
          monetizable={monetizable ?? MonetizableEnum.no}
          analyticsPayload={{
            index,
            offerId: id,
            institutionId: institution?.id,
            productId: product?.id,
            productType,
          }}
          linkType={LinkType.PRODUCT_IMAGE}
          sx={{ alignContent: 'center' }}
        >
          {children}
        </CtaLink>
      ) : (
        { children }
      )}
    </>
  );
};
